import { render, staticRenderFns } from "./AccionGeneral.vue?vue&type=template&id=489bb978&scoped=true&"
import script from "./AccionGeneral.vue?vue&type=script&lang=js&"
export * from "./AccionGeneral.vue?vue&type=script&lang=js&"
import style0 from "./AccionGeneral.vue?vue&type=style&index=0&id=489bb978&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489bb978",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('489bb978')) {
      api.createRecord('489bb978', component.options)
    } else {
      api.reload('489bb978', component.options)
    }
    module.hot.accept("./AccionGeneral.vue?vue&type=template&id=489bb978&scoped=true&", function () {
      api.rerender('489bb978', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/acciones/AccionGeneral.vue"
export default component.exports